export default "__VITE_ASSET__N48d2f_U__"